import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";


import { DynamicDialogService } from "../../core/services/dynamic-dialog.service";
import { Dialog, DialogButton } from "../../core/models/dialog.model";

import { AuthService } from "../../services/auth.service";
//import { DialogService } from "../../common/services/dialog.service";
import { UserIdentity } from "../../models/user-identity.model";
import { NavMenuComponent } from "./nav-menu.component";


@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

    @ViewChild("login") public loginLink: ElementRef;


    dialogDisplayed = false;
    timeoutSub: Subscription = null;

    cookieDialogText: string = "RICS uses cookies strictly to maintain user identity and session.  No marketing or other data is stored in a cookie beyond what is required to maintain the integrity of your user session.";

    cookieDialog: Dialog = new Dialog(this.cookieDialogText, [new DialogButton("Accept", true, () => this.acceptCookie(true)), new DialogButton("Decline", false, () => this.acceptCookie(false))]);


    userSubscription: Subscription = new Subscription();

    _user: UserIdentity;

    get user(): UserIdentity {
        return this._user;
    }

    constructor(public readonly authService: AuthService, public readonly router: Router,
        public dialogService: DynamicDialogService) {
    }

    ngOnInit(): void {
        
        if (this.timeoutSub) return;
        this.dialogDisplayed = false;
        this.timeoutSub = this.authService.promptTimeout.subscribe(x => {
            if (this.dialogDisplayed) return;
            this.dialogDisplayed = true;
            let stype = 'login';
            if (!this.isLoggedIn) {
                stype = 'session';
            }
            //console.log('dialog displayed');
            let dialog: Dialog = new Dialog(`Your ${stype} is about to expire, would you like to refresh your access?`, [new DialogButton("Yes", true, () => this.onDialogConfirm()), new DialogButton("No", false, () => this.onDialogClose())]);
            dialog.toggleDialog(true);
            this.dialogService.updateDialog(dialog);
        });
        this.userSubscription = this.authService.loggedInUser$.subscribe(
            (user) => { this._user = user; },
            (error) => {
                console.error(error);
            });
    }

    ngOnDestroy(): void {
        if (this.timeoutSub) this.timeoutSub.unsubscribe();
        if (this.userSubscription) this.userSubscription.unsubscribe();       
    }

    get isLoggedIn(): boolean {
        let result: boolean = false;
        if (this._user != null) {
            result = this._user.isLoggedIn;
        }
        return result;
    }


    get acceptedCookies(): boolean {
        let value = this.authService.cookieAcceptance;
        return value;
    }

    acceptCookie(accept: boolean): void {
        this.authService.cookieAcceptance = accept;
        if (accept) {
            this.executeLogin();

        }
    }

    executeLogin(): void {
        if (this.loginLink != null) (<HTMLAnchorElement>this.loginLink.nativeElement).click();
    }

    public onDialogConfirm(): void {
        //console.log('header onDialogConfirm');
        this.dialogDisplayed = false;
        this.authService.refreshToken();
    }

    public onDialogClose(): void {
        // console.log('header onDialogClose?');
        this.dialogDisplayed = false;
    }

    promptCookiesBeforeLogin(): void {
        if (this.acceptedCookies) {
            this.executeLogin();
        } else {
            this.showCookieDialog();
        }
    }



    login(): void {
        window.location.href = "/api/login";
    }
    logout(): void {
        this.router.navigate(["auth", "logout"]);
    }

    showCookieDialog(): void {
        this.cookieDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.cookieDialog);
    }
}
